import React, { createContext, useContext, useEffect } from 'react';
import { useEagerConnect, useInactiveListener } from '../hooks';

interface ChainContextType {
  // Add any context values if needed
  initialized: boolean;
}

const ChainContext = createContext<ChainContextType>({ initialized: false });

export const ChainProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // Initialize eager connect and inactive listeners
  useEagerConnect();
  useInactiveListener();

  return (
    <ChainContext.Provider value={{ initialized: true }}>
      {children}
    </ChainContext.Provider>
  );
};

export const useChainContext = () => {
  const context = useContext(ChainContext);
  if (!context) {
    throw new Error('useChainContext must be used within a ChainProvider');
  }
  return context;
};
